import PhoneInput from 'react-phone-input-2';
import { techTheme, theme } from 'src/features/common/app/components/theme-provider/theme';
import { FlexBox } from 'src/ui/common/atoms/flex-box';
import { Typography } from 'src/ui/common/atoms/typography';
import { media } from 'src/ui/common/mixins/media';
import { Badge } from 'src/ui/white-labels/techcontemporary/atoms/badge/index';
import { Button } from 'src/ui/white-labels/techcontemporary/atoms/button';
import styled, { css } from 'styled-components';

interface Props {
    withGap?: boolean;
}

const STATE_COLORS = {
    success: theme.colors.cyan500,
    error: theme.colors.red400,
};

type StateType = keyof typeof STATE_COLORS;

export const StyledWrapper = styled.div``;
const columnMixin = css<Props>`
    gap: 24px;
    margin-bottom: ${({ withGap }) => withGap && '24px'};

    ${media.sm`
        flex-direction: row;
    `}
    > div {
        flex: 1;

        input {
            width: 100%;
        }
    }
`;

export const StyledColumns = styled(FlexBox)<Props>`
    ${columnMixin}
`;

export const StyledColumnsResponsive = styled.div<Props>`
    display: flex;
    flex-direction: column;
    ${columnMixin}

    ${media.sm`
    flex-direction: row;
  `}
`;

export const StyledInputWrapper = styled.div`
    display: flex;
    flex-direction: column;
    gap: 5px;
`;

export const StyledEmailInputWrapper = styled(StyledInputWrapper)`
    flex: 4 !important;
    position: relative;
`;

export const StyledPhoneInput = styled(PhoneInput)`
    .input-styles {
        width: 100%;
        height: 48px;
        padding: 12px 12px 12px 58px;
        font-family: ${({ theme }) => theme.fonts.text};
        font-weight: 400;
        font-size: 16px;
        color: ${({ theme }) => theme.colors.lightGrey};
        background: ${({ theme }) => theme.colors.grey800};
        border-radius: 8px;
        border: 1px solid ${techTheme.colors.grey800};

        &:disabled {
            border-color: ${techTheme.colors.gs450};
            color: ${techTheme.colors.grey400};
        }

        ::-webkit-input-placeholder {
            color: ${({ theme }) => theme.colors.gs100};
        }

        ::-webkit-outer-spin-button,
        ::-webkit-inner-spin-button,
        &[type='number'] {
            -webkit-appearance: none;
            margin: 0;
        }

        &:hover {
            outline: none;
            border-color: ${techTheme.colors.gs450};
        }

        &:focus {
            outline: none;
            -webkit-appearance: none;
            border: 1px solid ${techTheme.colors.gs450};
            background: ${({ theme }) => theme.colors.grey800};
            box-shadow: none;
        }

        &::placeholder {
            color: ${techTheme.colors.grey400};
        }
    }

    .country-list {
        background: ${({ theme }) => theme.colors.grey800};
    }

    .country-list li.country:hover {
        background: rgba(255, 255, 255, 0.06);
    }

    .country-list .country.highlight {
        background: rgba(255, 255, 255, 0.06);
    }

    .country-list .country {
        font-family: ${({ theme }) => theme.fonts.text};
    }

    .country-list li.country .country-name {
        color: ${({ theme }) => theme.colors.white};
    }

    .dropdown-styles .selected-flag:focus:before,
    .dropdown-styles .selected-flag.open:before {
        border: none;
        box-shadow: none;
    }
`;

export const StyledSubTitle = styled(Typography)`
    max-width: 590px;
`;

export const StyledFlexBox = styled(FlexBox)`
    gap: 10px;
`;

export const StyledUpdateButton = styled(Button)`
    margin-top: 30px;
`;

export const StyledVerifyButton = styled(Button)`
    ${media.sm`
    margin-top: 24px;
    `}
`;

export const StyledBadgeWrapper = styled(Badge)<{ hasError: boolean }>`
    position: absolute !important;
    top: ${({ hasError }) => (hasError ? '33.5%' : '46%')};
    right: 10px;
    height: 28px;
    width: fit-content;
`;

export const StyledHelpMessage = styled.span<{ state: StateType }>`
    display: block;
    color: ${({ theme, state }) => (state ? STATE_COLORS[state] : theme.colors.gs200)};
    font-size: 14px;
    font-weight: 400;
    margin-top: 10px;
`;